<template>
  <b-pagination
    @change="(val) => $emit('change', val)"
    :per-page="perPage"
    :size="size"
    :value="value"
    :align="align"
    :total-rows="total"
    ellipsis-class="d-none"
    class="m-0"
    hide-ellipsis
  ></b-pagination>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BasePagination",
  props: {
    size: String,
    pageCount: Number,
    total: Number,
    value: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    align: {
      type: String,
      validator: (value) => ["start", "center", "end"].includes(value),
    },
  },
});
</script>
